import { Outlet, useLocation } from 'react-router-dom';
import { css } from '@emotion/react';
import ChatReportBottomSheet from '~/components/common/BottomSheet/ChatReport/ChatReportBottomSheet';
import { HeaderChatRoom } from '~/components/common/Header';
import { breakpoint } from '~/styles/themes';
import { useCommonChatStore, useGroupChatStore } from '~/store';

export default function LayoutChat() {
  const { pathname } = useLocation();

  const { isReportOpen, setIsReportOpen } = useCommonChatStore((state) => ({
    isReportOpen: state.isReportOpen,
    setIsReportOpen: state.setIsReportOpen,
  }));
  const { step } = useGroupChatStore((state) => ({
    step: state.enterGroupChatStep,
  }));

  const findType = (url: string) => {
    if (url.includes('chat') && !url.includes('group')) {
      return 'chat';
    } else if (url.includes('group')) {
      return 'groupChat';
    } else {
      return 'chat';
    }
  };
  const type = findType(pathname);

  const showHeader =
    type !== 'groupChat' || (step !== 'CheckMember' && step !== 'Password');

  return (
    <>
      {showHeader && <HeaderChatRoom type={type} />}
      <div
        css={css`
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          max-width: ${breakpoint.mobile_large};
          height: 100%;
          margin: 0 auto;
        `}
      >
        <Outlet />
      </div>
      <ChatReportBottomSheet
        isOpen={isReportOpen}
        onClose={() => setIsReportOpen(false)}
      />
    </>
  );
}
